/**
 * @file `Fetchvigator`, theLivin SokoDelivery fetch library - Makes all API requests to the SokoDelivery API using the JavaScript Fetch Library and stores the data returned in a collection.
 * @author Robert Ayetey
 * @author Keziah Odoi
 */

import Vue from "vue";
const state = {
  /**
   * Stores data returned from `makeFetch`.
   */
  collection: {
    user: {},
    vehicles: {},
    distance: {},
    cost: {},
    rider: {},
    orders: [],
    allQuestions: [],
  },
};

const getters = {
  /**
   * Returns state collection data with name `collectionName`
   * @param {object} state - The store state propery. User does not have to explicitly pass it to the function.
   * @returns {function} Retrieves collection with name `collectionName` and then returns an `empty array` if the collection does not exist but `the collection` if it exists in the state's `collection` object
   */
  getCollection: (state) => (collectionName) => {
    const cn = collectionName;
    if (state.collection[cn]) return state.collection[cn];
    console.error(`No collection with name ${cn}!`);
    return [];
    // console.log(state);
    // console.log(state.collection);
    // console.log(state.collection["admins"]);
    // console.log(cn);
  },
};

const actions = {
  /**
   * Customize fetch request by specifying which request to make, how to make it and where the response data should be stored.
   * @param {function} commit - boundCommit, an implicit commit extracted from the state and used to commit a mutation
   * @param {{method: !string, body: ?object, withId: ?boolean, addUrl: ?string}} payload - Describes how `makeFunction` should be executed.
   * @returns {Promise<boolean>} True if function is executed successfuly but false if otherwise
   */
  makeFetch: async ({ commit }, payload) => {
    // build url ie. api endpoint for the fetch
    let url = `${process.env.VUE_APP_BACKEND_API_ENDPOINT}/`;

    if (!payload.goTo) url = `${url}user`;
    else url = `${url}${payload.goTo}`;

    // - get the current logged in user's id from the store
    const uid = localStorage.getItem("uid");
    const sdtkn = localStorage.getItem("sdtkn");

    // - add the current logged in user's id to the url if specified
    if (payload.withId) url += `/${uid}`;

    // - add any additional url parameter to the url if specified
    if (payload.addUrl) url += `${payload.addUrl}`;

    // build the options for the fetch
    // - capitalize the method
    const method = String(payload.method).toUpperCase();
    let fetchOptions = {
      mode: "cors",
      credentials: "include",
      method,
      headers: {
        Authorization: "Bearer " + sdtkn,
      },
    };

    // create the headers
    const moreHeaders = {
      "Content-Type": "application/json",
    };

    // check if there is a need to add the headers and a body to the options
    // and add if neccessary
    const noBodyReqMethods = ["GET", "HEAD"];
    noBodyReqMethods.includes(method) ||
      (fetchOptions = {
        ...fetchOptions,
        headers: {
          ...fetchOptions.headers,
          ...moreHeaders,
        },
        body: JSON.stringify(payload.body),
      });
    // make the fetch request to the api using the build url
    const response = await fetch(url, fetchOptions);

    // console.log(response);

    if (response.ok) {
      const jsonBody = await response.json();
      // commit the changes for mutation on the stateVar variable supplied through payload
      // console.log(jsonBody);
      // state[payload.stateVar].push(jsonBody)

      // console.log(jsonBody);

      if (payload.stateVar) {
        commit("SET_COLLECTION", {
          jsonBody,
          target: payload.stateVar,
        });
      }

      if (payload.returnData) {
        return jsonBody;
      } else return true;
    }

    console.error("Failed to Fetch");
    return false;

    // console.log(fetchOptions);
    // console.log(method);
    // console.log(payload);
    // console.log(url);
    // console.log(commit);
  },

  updateCollection({ commit }, payload) {
    commit("UPDATE_STATE", payload);
  },
};

const mutations = {
  /**
   * Stores data in the `state.collection`
   * @param {object} state - State of store
   * @param {object} data - Data to store and where to store it in the store's collection
   */
  SET_COLLECTION(state, data) {
    const target = data.target;
    const body = data.jsonBody;

    // Create collection if state is not already created and put the data in it
    if (!state.collection[target] || state.collection[target].length <= 0) {
      // console.log(target + " is empty");
      Vue.set(state.collection, target, body);
      // state.collection[target] = body;
    }
    // Put the data in the state if it already there
    else {
      const newDataOnly = [
        "user",
        "vehicles",
        "cost",
        "distance",
        "orders",
        "rider",
      ];
      if (newDataOnly.includes(target)) {
        state.collection[target] = body;
        return;
      }
      state.collection[target].push(body);
      // state[target] = [...state.target, body];
      // console.log(target + " is not empty");
      // console.log(body);
    }

    // console.log(state);
    // console.log(state.collection);
    // console.log(data);
    // console.log(state.collection[data.target]);
  },

  UPDATE_STATE(state, payload) {
    const { target, collection, data } = payload;
    const { current } = data;
    const cn = collection;

    const updatedData = [...state.collection[cn]];

    updatedData.map((item) => {
      if (item.orderid === target) item.orderstatus = current.orderstatus;
    });

    state.collection[cn] = [...[], ...updatedData];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
